var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"parallax"}},[_c('div',{ref:"bg1",style:({ backgroundSize: 'auto 100%' })}),_c('div',{ref:"bg2",style:({ backgroundSize: 'auto 100%' })}),_c('div',{ref:"bg3",style:({ backgroundSize: 'auto 100%' })}),_c('div',{ref:"bg4",style:({ backgroundSize: 'auto 100%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }